var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("generic-modal", {
        ref: "manageSubscriptionModal",
        attrs: { id: "manage-subscriptions-modal", "modal-dialog-size": "lg" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_vm._v("\n      " + _vm._s(_vm.manageText) + "\n    ")]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "text-left right-inner-addon mb-4",
                        attrs: { cols: "12" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "right-inner-addon" },
                          [
                            _c("icon", { attrs: { name: "search" } }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.search,
                                  expression: "search",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass:
                                "form-control search-inactive-clients",
                              attrs: {
                                id: "search-agent-input",
                                type: "search",
                                placeholder: _vm.$t("agents.searchFor"),
                                autocomplete: "off",
                              },
                              domProps: { value: _vm.search },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.search = $event.target.value.trim()
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "d-none",
                                attrs: { for: "search-agent-input" },
                              },
                              [_vm._v(_vm._s(_vm.$t("agents.searchFor")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-client-table", {
                          staticClass: "vue-custom-table no-pagination",
                          attrs: {
                            data: _vm.filteredAgents,
                            options: _vm.options,
                            columns: _vm.options.columns,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "h__selected",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-group-checkbox",
                                      class: {
                                        disabled: !_vm.areAgentsToSubscribe,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                        },
                                        [
                                          _c("input", {
                                            ref: "selectAll",
                                            staticClass: "checkbox",
                                            attrs: {
                                              id: "select-all",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: _vm.allAgentsMarked,
                                            },
                                            on: {
                                              click: _vm.handleSelectAllAgents,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "state p-success" },
                                            [
                                              _c("icon", {
                                                staticClass: "icon",
                                                attrs: { name: "check" },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "text-light-gray",
                                                  attrs: { for: "select-all" },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.actions.selectAll"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "selected",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "form-group-checkbox" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pretty p-icon p-jelly p-smooth p-curve mr-0",
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "checkbox",
                                            attrs: {
                                              id:
                                                "select-recipient-" +
                                                row.username,
                                              type: "checkbox",
                                              "true-value": "true",
                                              name:
                                                "select-recipient-" +
                                                row.username,
                                            },
                                            domProps: {
                                              checked:
                                                _vm.agentIsSelected(
                                                  row.username
                                                ) && !row.active,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSelectAgent(
                                                  row
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "state p-success" },
                                            [
                                              _c("icon", {
                                                staticClass: "icon",
                                                attrs: { name: "check" },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "text-light-gray hidden-text",
                                                  attrs: {
                                                    for:
                                                      "select-recipient-" +
                                                      row.username,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.words.agent"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "fullName",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "profile-avatar",
                                        _vm._b(
                                          {
                                            staticClass:
                                              "client-avatar d-none d-lg-block",
                                          },
                                          "profile-avatar",
                                          row,
                                          false
                                        )
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mx-2" }, [
                                        _c(
                                          "span",
                                          { staticClass: "bold text-grey" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm._f("fullName")(
                                                    _vm.GET_AGENT(row.username)
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        row.username ===
                                        _vm.CURRENT_USER_USERNAME
                                          ? _c(
                                              "span",
                                              { staticClass: "font-sm" },
                                              [
                                                _vm._v(
                                                  "\n                    (" +
                                                    _vm._s(
                                                      _vm.$t("global.words.you")
                                                    ) +
                                                    ")\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "status",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "badge",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: {
                                            title: _vm.$t(
                                              "account.accountPlan.perks.thisAgentIsSubscribed"
                                            ),
                                            disabled: !row.active,
                                          },
                                          expression:
                                            "{\n                  title: $t(\n                    'account.accountPlan.perks.thisAgentIsSubscribed'\n                  ),\n                  disabled: !row.active\n                }",
                                        },
                                      ],
                                      staticClass:
                                        "m-0 badge-notification float-none",
                                      attrs: {
                                        type: row.active
                                          ? "light-gray"
                                          : "success",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            row.active
                                              ? "Expert Pro"
                                              : "Expert Plus"
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c("simple-button", {
                  attrs: {
                    type: _vm.mode === "add" ? "primary" : "danger",
                    "class-name": "btn-sm",
                    text: _vm.manageText,
                    disabled: !_vm.canSubmit,
                    loading: _vm.loading,
                    "loading-succeeded": _vm.loadingSucceeded,
                  },
                  on: { finish: _vm.closeModal, click: _vm.handleSubmit },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("cancel-plan-confirmation", {
        attrs: {
          show: _vm.showCancelModal,
          loading: _vm.loading,
          "agent-name": _vm.agentsInfo.agentName,
          "number-of-agents": _vm.agentsInfo.numberOfAgents,
        },
        on: {
          "update:show": function ($event) {
            _vm.showCancelModal = $event
          },
          "cancel-plan": _vm.handleSubmit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }